export const USER = "USER";
export const APPLICATION_DETAILS = "APPLICATION_DETAILS";
export const APPLICATION_COMMENT = "APPLICATION_COMMENT";
export const LOCATIONS = "LOCATIONS";
export const APPLICANT_TYPE = "APPLICANT_TYPE";
export const APPLICATION_TYPE = "APPLICATION_TYPE";
export const OCCUPANCY_TYPE = "OCCUPANCY_TYPE";
export const BLOCK = "BLOCK";
export const BUILDING = "BUILDING";
export const FLOOR = "FLOOR";
export const PREMISE_AREA = "PREMISE_AREA";
export const PREMISE_TYPE = "PREMISE_TYPE";
export const ROLE = "ROLE";
export const ZONE = "ZONE";
export const ROAD = "ROAD";
export const DOCUMENT_CATEGORY = "DOCUMENT_CATEGORY";
export const DOCUMENT_TYPE = "DOCUMENT_TYPE";
export const ACCESSORIES = "ACCESSORIES";
export const APPLICATION_STATUS = "APPLICATION_STATUS";
export const APPROVED_APPLICATION_DOCUMENT = "APPROVED_APPLICATION_DOCUMENT";
export const CHATBOT = "CHATBOT";
export const CONSUMER_COMPLAINT = "CONSUMER_COMPLAINT";
export const CONSUMER_COMPLAINT_CONVERSATION =
  "CONSUMER_COMPLAINT_CONVERSATION";
export const FEEDBACK = "FEEDBACK";
export const MEASUREMENT_TYPE = "MEASUREMENT_TYPE";
export const TARIFF = "TARIFF";
export const UTILITY = "UTILITY";
export const UTILITY_APPLICATION = "UTILITY_APPLICATION";
export const UTILITY_ISSUE = "UTILITY_ISSUE";
export const LOCATION_BY_PINCODE = "LOCATION_BY_PINCODE";
export const UTILITY_CONSUMER = "UTILITY_CONSUMER";
export const CONSUMER = "CONSUMER";
export const TECHNICAL_SANCTION = "TECHNICAL_SANCTION";
export const DEMAND_ESTIMATE = "DEMAND_ESTIMATE";
export const CITY = "CITY";
export const PINCODE = "PINCODE";
export const UTILITY_TYPE_MAPPING = "UTILITY_TYPE_MAPPING";
export const NOTIFICATION = "NOTIFICATION";
export const BILLING_CYCLE = "BILLING_CYCLE";
export const UNPAID_BILLS = "UNPAID_BILLS";
export const METER_READING = "METER_READING";
export const BILLING_CALCULATIONS = "BILLING_CALCULATIONS";
export const CHARGES = "CHARGES";
export const CONSUMER_BILLING = "CONSUMER_BILLING";
export const MY_BILLS = "MY_BILLS";
export const PAYMENT_HISTORY = "PAYMENT_HISTORY";
export const UTILITY_CONSUMER_METER = "UTILITY_CONSUMER_METER";
export const SOURCE_OF_POWER = "SOURCE_OF_POWER";
export const USER_DOCUMENTS = "USER_DOCUMENTS";
export const SECURITY_DEPOSIT = "SECURITY_DEPOSIT";
export const BACKUP_POWER = "BACKUP_POWER";
export const MENU_ITEMS = "MENU_ITEMS";
export const OTHER_APPLICATION_DETAILS = "OTHER_APPLICATION_DETAILS";
export const DISPATCHED_BILL = "DISPATCHED_BILL";
export const POWER_ABSTRACT = "POWER_ABSTRACT";
export const USER_MANAGEMENT = "USER_MANAGEMENT";
export const OFFLINE_PAYMENT = "OFFLINE_PAYMENT";
export const MISSING_READINGS = "MISSING_READINGS";
export const FIRE_SAFETY = "FIRE_SAFETY";
export const AUDIT_SCHEDULE = "AUDIT_SCHEDULE";
export const REGISTER_BUILDING = "REGISTER_BUILDING";
export const FIRE_SAFETY_APPLICATION = "FIRE_SAFETY_APPLICATION";
export const DEBIT_NOTE = "DEBIT_NOTE";
export const CREDIT_NOTE = "CREDIT_NOTE";

export const FIRE_SAFETY_BUILDING_OBSERVATION =
  "FIRE_SAFETY_BUILDING_OBSERVATION";
export const FIRE_SAFETY_COMMENT = "FIRE_SAFETY_COMMENT";
export const AUTHORIZED_USERS = "AUTHORIZED_USERS";
export const UTILITY_TUNNEL = "UTILITY_TUNNEL";
export const ACCESS_APPLICATION = "ACCESS_APPLICATION";
export const APPROVAL_TRACKING = "APPROVAL_TRACKING";
export const FIRE_SAFTEY_PREMISE_TYPE = "FIRE_SAFTEY_PREMISE_TYPE";
export const FIRE_SAFETY_DETAIL_OBSERVATION_OPTION = "FIRE_SAFETY_DETAIL_OBSERVATION_OPTION";
export const CGRF = "CGRF";

export const tagTypes = [
  AUTHORIZED_USERS,
  ACCESSORIES,
  APPLICANT_TYPE,
  APPLICATION_COMMENT,
  APPLICATION_DETAILS,
  APPLICATION_STATUS,
  MISSING_READINGS,
  APPLICATION_TYPE,
  APPROVED_APPLICATION_DOCUMENT,
  BLOCK,
  BUILDING,
  FIRE_SAFETY,
  FIRE_SAFETY_APPLICATION,
  BUILDING,
  CHATBOT,
  CONSUMER_COMPLAINT,
  CONSUMER_COMPLAINT_CONVERSATION,
  DOCUMENT_CATEGORY,
  DOCUMENT_TYPE,
  OFFLINE_PAYMENT,
  FEEDBACK,
  FLOOR,
  LOCATIONS,
  MEASUREMENT_TYPE,
  OCCUPANCY_TYPE,
  PREMISE_AREA,
  PREMISE_TYPE,
  ROAD,
  ROLE,
  TARIFF,
  USER,
  UTILITY,
  UTILITY_APPLICATION,
  UTILITY_ISSUE,
  ZONE,
  CITY,
  LOCATION_BY_PINCODE,
  UTILITY_CONSUMER,
  CONSUMER,
  TECHNICAL_SANCTION,
  DEMAND_ESTIMATE,
  PINCODE,
  UTILITY_TYPE_MAPPING,
  NOTIFICATION,
  BILLING_CYCLE,
  UNPAID_BILLS,
  METER_READING,
  BILLING_CALCULATIONS,
  CHARGES,
  PAYMENT_HISTORY,
  CONSUMER_BILLING,
  MY_BILLS,
  UTILITY_CONSUMER_METER,
  SOURCE_OF_POWER,
  USER_DOCUMENTS,
  SECURITY_DEPOSIT,
  BACKUP_POWER,
  MENU_ITEMS,
  DISPATCHED_BILL,
  OTHER_APPLICATION_DETAILS,
  POWER_ABSTRACT,
  AUDIT_SCHEDULE,
  USER_MANAGEMENT,
  REGISTER_BUILDING,
  DEBIT_NOTE,
  FIRE_SAFETY_BUILDING_OBSERVATION,
  FIRE_SAFETY_COMMENT,
  UTILITY_TUNNEL,
  FIRE_SAFTEY_PREMISE_TYPE,
  FIRE_SAFETY_DETAIL_OBSERVATION_OPTION,
  CGRF,
];
